<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" 
    :style="{ backgroundImage: 'url(' + header_pictures.home_header_picture.url + ')' }">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">{{home_page.header}}</h1>
            <h4>
              {{home_page.subheader}}
            </h4>
            <br />
            <md-button
              href="/products"
              class="md-primary md-lg"
              >View Products</md-button
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <section class="categories">
          <h2>All Product Categories</h2>
          <br>
          <CategoriesContainer
            :categories=categories
          ></CategoriesContainer>
          <br>
          <h2>Featured Products</h2>
          <Loader v-if="productsloading"/>
          <Newestproducts
            v-else
            :products=featuredproducts
          ></Newestproducts>
          <br><br><br>
        </section>
        <section class="home-news">
          <div class="home-news-content">
            <h2 class="title">News</h2>
            <div class="home-news-items-container">
              <div class="home-news-item" v-for="news_post in news" :key="news_post.id">
                <img :src=news_post.main_picture.url>

                <router-link :to="'/news/' + news_post.slug">
                  <h3 class="title">{{news_post.title}}</h3>
                </router-link>
              </div>

            </div>
            <br>
            <md-button
              href="/news"
              class="button-news md-primary"
              >View All News</md-button
            >
          </div>
          
          
        </section>
        <br>
        <br>
        <div class="brands-section  text-center">
          <!-- <h2 class="title text-center">Brands</h2> -->
          <Loader v-if="brandsloading"/>
          <div class="brands-container" v-else>
            <div v-for="brand in brands" :key="brand.id">
              <div v-if="brand.Logo">
                <img :src=brand.Logo.formats.thumbnail.url :alt=brand.Logo.alternativeText>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CategoriesContainer from "@/components/CategoriesContainer.vue";
import Newestproducts from "@/components/Newestproducts.vue";
import Loader from "@/components/Loader.vue";

export default {
  bodyClass: "landing-page",
  components: {
    CategoriesContainer,
    Newestproducts,
    Loader
  },
  props: {
    header_pictures: Object,
  },
  
  data() {
    return {
      
      brands: [],
      home_page: {},
      brandsloading: true,
      featuredproducts: [],
      productsloading: true,
      news: [],
      categories: [],
    };
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/home-page", {}).then(
      (response) => {
        this.home_page = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/products?featured=true&_limit=10", {}).then(
      (response) => {
        this.featuredproducts = response.data;
        this.productsloading = false;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/brands", {}).then(
        (response) => {
            this.brands = response.data;
            this.brandsloading = false;
        },
        (error) => {
            // console.log(error);
        }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/news-posts?_sort=published_at:desc&_limit=3", {}).then(
        (response) => {
            this.news = response.data;
        },
        (error) => {
            // console.log(error);
        }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/categories?_sort=Name:ASC", {}).then(
      (response) => {
        this.categories = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  metaInfo() {
    return{
      title: 'Home',
      meta: [
        { name: 'description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:title', content: "Asiong's Industrial Products"},
        { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:site_name', content: 'Asiongs Industrial Products'},
        { property: 'og:type', content: 'website'},    
        { property: 'og:image', content: this.header_pictures.home_header_picture.url}
      ]
    }
  }
};
</script>

<style lang="scss" scoped>

.categories{
  padding: 24px;
  max-width: 1440px;
  margin: auto;
}

.home-news{
  background-color: #182e5a;

  .home-news-content{
    max-width: 1440px;
    margin: auto;
    padding: 48px 24px;

    h2{
      color: white;
      // margin: 32px 0px;
    }

    .home-news-items-container{
      display: grid;
      
      grid-auto-rows: 1fr;
      grid-gap: 16px;

      .home-news-item{
        border: 2px solid white;

        h3{
          color: white;
          margin: 8px;
          &:hover {
            color:#dddddd;
          }
        }
      }
    }
  }
  
}

@media only screen and (min-width: 992px) {
  .home-news-items-container{
    grid-template-columns: repeat(auto-fit, minmax(440px, 1fr));
  }
}

@media only screen and (max-width: 991px) {
  .home-news-items-container{
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
}

.brands-container{
  display: grid;
  margin: auto;
  padding: 0px 64px ;
  grid-template-columns: repeat(auto-fit, minmax(144px , 1fr));
  gap: 8px;
}

.button-news{
  background-color: #182e5a;
  color: white;
  border: 2px solid white;
}

</style>
